import React, { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * PdfPreviewSection - Rein visuelle Komponente für die Anzeige.
 * Sie hält keine eigene Logik mehr und flackert daher nicht bei Rerenders.
 */
const PdfPreviewSection = memo(({
    pdfUrl,
    loading,
    error
}) => {
    if (loading && !pdfUrl) {
        return (
            <div className="pdf-generation-loading">
                <div className="spinner">⌛</div>
                <span>Dokument wird generiert...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pdf-generation-error">
                ⚠️ Fehler bei der PDF-Erstellung: {error}
            </div>
        );
    }

    if (!pdfUrl) return null;

    return (
        <iframe
            key={pdfUrl}
            src={`${pdfUrl}#toolbar=1`}
            className="export-preview-iframe"
            title="PDF Vorschau"
            style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '12px',
                background: 'white'
            }}
        />
    );
});

PdfPreviewSection.displayName = 'PdfPreviewSection';

PdfPreviewSection.propTypes = {
    pdfUrl: PropTypes.string,
    loading: PropTypes.boolean,
    error: PropTypes.string
};

export default PdfPreviewSection;
